__turbopack_context__.v({
  "expandButton": "HomeBlock-module-scss-module__WJgN2a__expandButton",
  "grid": "HomeBlock-module-scss-module__WJgN2a__grid",
  "gridCarousel": "HomeBlock-module-scss-module__WJgN2a__gridCarousel",
  "gridMeta": "HomeBlock-module-scss-module__WJgN2a__gridMeta",
  "gridRow": "HomeBlock-module-scss-module__WJgN2a__gridRow",
  "header": "HomeBlock-module-scss-module__WJgN2a__header",
  "meta": "HomeBlock-module-scss-module__WJgN2a__meta",
  "title": "HomeBlock-module-scss-module__WJgN2a__title",
});
